import Select from 'react-select'
import './TextMatchInput.scoped.scss'

const OPERATOR_OPTIONS = [
  { value: 'is', label: 'is' },
  { value: 'contains', label: 'contains' },
  { value: 'starts_with', label: 'starts with' },
  { value: 'ends_with', label: 'ends with' },
  { value: 'present', label: 'has value' },
  { value: 'empty', label: 'is empty' },
]

const OPERATORS_WITHOUT_VALUE = ['present', 'empty']

export default function TextMatchInput({ value, onChange }) {
  const safeValue = value && typeof value === 'object' ? value : { operator: 'contains', value: '' }
  const operator = safeValue.operator || 'contains'
  const needsValue = !OPERATORS_WITHOUT_VALUE.includes(operator)

  function handleOperatorChange(option) {
    if (OPERATORS_WITHOUT_VALUE.includes(option.value)) {
      onChange({ operator: option.value })
    } else {
      onChange({ operator: option.value, value: safeValue.value || '' })
    }
  }

  return (
    <div className="text-match-input">
      <div className="text-match-operator">
        <Select
          options={OPERATOR_OPTIONS}
          value={_.find(OPERATOR_OPTIONS, { value: operator })}
          onChange={handleOperatorChange}
        />
      </div>
      {needsValue && (
        <input
          type="text"
          value={safeValue.value || ''}
          onChange={(e) => onChange({ ...safeValue, value: e.target.value })}
        />
      )}
    </div>
  )
}
